import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer 
      className="sticky-footer"
      style={{
        backgroundColor: '#6E21A1', // Dark purple background
        color: '#ffcc00', // Yellow text
        padding: '2px 0px',
        fontSize: '11px',
        borderTop: 'none',
        marginTop: 'auto',
        zIndex: 1,
        bottom: 0,
        width: '100%',
        left: 0,
        position: 'fixed'
      }}
    >
      <div className="container-fluid d-flex justify-content-end align-items-center">

        {/* Right side - Legal links */}
        <div className="footer-links d-flex align-items-center gap-5">
          <span>© 2025 devaswom.in</span>
          <Link 
            to="/legal" 
            className="text-decoration-none"
            style={{ color: '#ffcc00' }}
          >
            Terms of use
          </Link>
          <Link 
            to="/legal" 
            className="text-decoration-none"
            style={{ color: '#ffcc00' }}
          >
            Privacy & cookies
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
